import { getAnsweredValue, MatcherAnswers } from './types';

function getNameParts(answers: MatcherAnswers): [string, string] {
  const name = getAnsweredValue(answers.name);
  return Array.isArray(name) ? [name[0] ?? '', name[1] ?? ''] : ['', ''];
}

export { getNameParts };
